// Load HubSpot embed script ONCE
if (!window.hubspotEmbedScriptLoaded) {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/49488442.js';
    script.defer = true;
    script.onload = function() {
      window.hubspotEmbedScriptLoaded = true;
    };
    document.head.appendChild(script);
  }

  // Define the CustomDrawer element
  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.formLoaded = false;
    }

    connectedCallback() {
      this.drawer = this.querySelector('.custom-drawer');
      this.overlay = this.querySelector('.custom-drawer__overlay');
      this.closeBtn = this.querySelector('#close-custom-drawer');
      this.loadingEl = this.querySelector('#form-loading');
      this.formContainer = this.querySelector('#hubspot-form-container');
      
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
    }

    open() {
      this.isOpen = true;
      this.drawer.classList.add('open');
      document.body.classList.add('overflow-hidden');
      this.overlay.style.display = 'block';
      
      // Always show loading first
      this.loadingEl.style.display = 'flex';
      this.formContainer.style.display = 'none';
      
      // Load/reload form
      this.loadForm();
    }

    loadForm() {
      if (!window.hubspotEmbedScriptLoaded) {
        setTimeout(() => this.loadForm(), 100);
        return;
      }
      
      // Clear previous form
      this.formContainer.innerHTML = '';
      
      // Create fresh form embed
      const formDiv = document.createElement('div');
      formDiv.className = 'hs-form-frame';
      formDiv.setAttribute('data-region', 'na1');
      formDiv.setAttribute('data-form-id', 'd4cefa7d-c946-4f6e-8bdd-c85bb67c9306');
      formDiv.setAttribute('data-portal-id', '49488442');
      
      this.formContainer.appendChild(formDiv);
      
      // Hide loading + show form + track (with small delay for smooth UX)
      setTimeout(() => {
        this.loadingEl.style.display = 'none';
        this.formContainer.style.display = 'block';
        
        if (window._hsq) {
          window._hsq.push(['trackCustomBehavioralEvent', {
            name: 'academy_waitlist_drawer_view',
            properties: {
              form_id: 'd4cefa7d-c946-4f6e-8bdd-c85bb67c9306',
              context: 'drawer_opened'
            }
          }]);
          console.log('✅ Form loaded + tracked');
        }
      }, 800);
    }

    close() {
      this.isOpen = false;
      this.drawer.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      this.overlay.style.display = 'none';
      
      // 🔧 RESET - allows reload next time
      this.formLoaded = false;
    }
  }

  customElements.define('custom-drawer', CustomDrawer);

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest('[data-custom-drawer-open]');
    if (!trigger) return;

    event.preventDefault();
    const drawer = document.querySelector('custom-drawer');
    if (!drawer) return;

    drawer.open();
  });
